export const naiFlowTabs = [
  {
    label: 'Whatsapp Group',
    path: `/project-management/:name/:id/nai-flow/whatsapp-group`,
    slug: 'whatsapp-group',
    page: 'nai-flow',
  },
  {
    label: 'Observations',
    path: `/project-management/:name/:id/nai-flow/observations`,
    slug: 'observations',
    page: 'nai-flow',
  },
  {
    label: 'Incidents',
    path: `/project-management/:name/:id/nai-flow/incidents`,
    slug: 'incidents',
    page: 'nai-flow',
  },
  {
    label: 'Inspections',
    path: `/project-management/:name/:id/nai-flow/inspections/schedule`,
    slug: 'inspections',
    page: 'nai-flow',
  },
  {
    label: 'Trainings',
    path: `/project-management/:name/:id/nai-flow/trainings`,
    slug: 'training',
    page: 'nai-flow',
  },
  {
    label: 'Statistics Capture',
    path: `/project-management/:name/:id/nai-flow/statistics-capture/schedule`,
    slug: 'statistics-capture',
    page: 'nai-flow',
  },
] as any

export const naiFlowViewTabs = [
  {
    label: 'Observations',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/observations`,
    slug: 'observations',
    page: 'nai-flow-view',
  },
  {
    label: 'Incidents',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/incidents`,
    slug: 'incidents',
    page: 'nai-flow-view',
  },
  {
    label: 'Trainings',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/trainings`,
    slug: 'training',
    page: 'nai-flow-view',
  },
] as any


export const projectUserManagementTabs = [
  {
    label: 'Users',
    slug: 'user',
    path: `/project-management/:name/:id/user-management/users`,
    page: 'project-user-management',
  },
  {
    label: 'Roles',
    slug: 'role',
    path: `/project-management/:name/:id/user-management/roles`,
    page: 'project-user-management',
  },
]

export const inspectionTabs = [
  {
    label: 'Schedule',
    path: `/project-management/:name/:id/nai-flow/inspections/schedule`,
    slug: 'schedule',
    page: 'inspections',
  },
  {
    label: 'Inspections List',
    path: `/project-management/:name/:id/nai-flow/inspections/list`,
    slug: 'inspections',
    page: 'inspections',
  },
  {
    label: 'Non-Conformance',
    path: `/project-management/:name/:id/nai-flow/inspections/non-conformance`,
    slug: 'non-conformance',
    page: 'inspections',
  },
]

export const statisticCaptureTabs = [
  {
    label: 'Schedule',
    path: `/project-management/:name/:id/nai-flow/statistics-capture/schedule`,
    slug: 'statistics-capture-schedule',
    page: 'statistics-capture',
  },
  {
    label: 'Report',
    path: `/project-management/:name/:id/nai-flow/statistics-capture/reports`,
    slug: 'statistics-capture-report',
    page: 'statistics-capture',
  },
]

export const naiFlowDashboardsTabs = [
  // {
  //   label: 'Overview',
  //   path: `/dashboard/nai-flow/overview`,
  //   slug: 'org-dashboard',
  //   page: 'nai-flow-dashboard',
  // },
  {
    label: 'Observation Old',
    path: `/dashboard/nai-flow/observation-old`,
    slug: 'observations-dashboard-old',
    page: 'nai-flow-dashboard-old',
  },
  {
    label: 'Observation',
    path: `/dashboard/nai-flow/observation`,
    slug: 'observations-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Incident',
    path: `/dashboard/nai-flow/incident`,
    slug: 'incidents-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Inspection',
    path: `/dashboard/nai-flow/inspection`,
    slug: 'inspections-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Training',
    path: `/dashboard/nai-flow/training`,
    slug: 'training-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Statistics Capture',
    path: `/dashboard/nai-flow/statistics-capture`,
    slug: 'statistics-capture-dashboard',
    page: 'nai-flow-dashboard',
  },
]

export const allTabs = [...naiFlowTabs, ...naiFlowViewTabs, ...projectUserManagementTabs, ...inspectionTabs, ...statisticCaptureTabs, ...naiFlowDashboardsTabs]
